<template>
  <b-card>
    <div class="mx-1">
    <b-row>
      <b-col md="12">
        <h5 class="mt-2">
          {{ $t("account_settings.appColors.title") }}
        </h5>
        <div style="width: 900px; text-align: justify">
          <p id="description" class="section-label mt-1 mb-2">
            {{ $t("account_settings.appColors.description") }}
          </p>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!showThemeBuilder">
      <b-col md="12">
        <div style="width: 900px; text-align: justify">
          <p id="description" class="section-label">
            {{ $t("account_settings.appColors.theme_builder_description") }}
          </p>
        </div>
        <div class="">
          <b-row class="d-flex flex-row">
            <!-- Per Page -->
            <b-col
              md="4"
              class="mt-2"
            >
              <label class="text-capitalize">{{ $t("table.show") }}</label>
              <v-select
                v-model="perPageThemes"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[10,20,50,100]"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
                @input="getThemes"
              />
              <label class="text-capitalize">{{ $t("table.entries") }}</label>
            </b-col>

            <!-- Tenant -->
            <b-col cols="12" md="4">
              <div class="">
                <b-form-group
                label="Tenant"
                label-for="id_tenant"
                >
                <v-select
                  data-cy="theme-tenant"
                  v-model="currentTenantSelected"
                  :options="tenantOptions"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :clearable="true"
                  :multiple="true"
                  :reduce="(val) => val.id"
                  input-id="id_tenant"
                  label="name"
                  class="themeNameInput"
                  @input="getThemes"
                />
              </b-form-group>
              </div>
            </b-col>

            <!-- Search -->
            <b-col cols="12" md="4" class="mt-2">
              <div class="">
                <b-form-input
                  @input="onTypeSearch"
                  v-model="search"
                  class="d-inline-block mr-1 themeNameInput"
                  :placeholder="$t('table.search') + '...'"
                />
              </div>
            </b-col>
          </b-row>
        </div>
        <div class="d-flex">
          <div class="mt-4" v-if="$can('create', 'AppColors')">
            <span class="align-self-start cursor-pointer" @click="openThemeBuilder({})">
              <feather-icon
                :title="`${$t('actions.add')}`"
                class=""
                icon="PlusCircleIcon"
                size="25"
                v-b-tooltip.hover
              />
            </span>
          </div>
          <div class="themes-container">
            <div class="d-flex flex-wrap align-items-end">
              <div class="themeItemContainer m-1" >
                <span v-if="currentThemeUsed && currentThemeUsed.id === 'default'">current selection</span>
                <div class="themeItem cursor-pointer mb-1 border" @click="selectNextTheme(defaultTheme)">
                  <div class="themeMockup">
                    <div class="themeMockupHeader navbar rounded-top" :style="{ backgroundColor: '#1b3d5e' }"></div>
                    <div class="themeMockupContent d-flex justify-content-between">
                      <div class="leftsidenav w-25 border" :style="{ backgroundColor: '#708599' }"></div>
                      <div class="grid border w-50" :style="{ backgroundColor: '#ffffff' }">
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                      </div>
                      <div class="rightsidenav border w-25" :style="{ backgroundColor: '#708599' }"></div>
                    </div>
                  </div>
                </div>
                <div class="themeName">Sbo default</div>
              </div>

              <div class="themeItemContainer m-1" v-if="currentThemeUsed && currentThemeUsed.id !== 'default'">
                <span>current selection</span>
                <div class="themeItem cursor-pointer mb-1 border">
                  <div class="themeMockup">
                    <div class="themeMockupHeader navbar rounded-top" :style="{ backgroundColor: currentThemeUsed.config.appColors.primary.value }"></div>
                    <div class="themeMockupContent d-flex justify-content-between">
                      <div class="leftsidenav w-25 border" :style="{ backgroundColor: currentThemeUsed.config.appColors.secondLight.value }"></div>
                      <div class="grid border w-50" :style="{ backgroundColor: currentThemeUsed.config.appColors.mainLight.value }">
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                      </div>
                      <div class="rightsidenav border w-25" :style="{ backgroundColor: currentThemeUsed.config.appColors.secondLight.value }"></div>
                    </div>
                  </div>
                </div>
                <div class="themeName">{{ currentThemeUsed.name }}</div>
              </div>

              <div class="themeItemContainer m-1" v-if="nextThemeToUse">
                <div class="themeItem cursor-pointer mb-1 border">
                  <div class="themeMockup">
                    <div class="themeMockupHeader navbar rounded-top" :style="{ backgroundColor: nextThemeToUse.config.appColors.primary.value }"></div>
                    <div class="themeMockupContent d-flex justify-content-between">
                      <div class="leftsidenav w-25 border" :style="{ backgroundColor: nextThemeToUse.config.appColors.secondLight.value }"></div>
                      <div class="grid border w-50" :style="{ backgroundColor: nextThemeToUse.config.appColors.mainLight.value }">
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                        <div class="grid-box"></div>
                      </div>
                      <div class="rightsidenav border w-25" :style="{ backgroundColor: nextThemeToUse.config.appColors.secondLight.value }"></div>
                    </div>
                  </div>
                </div>
                <div class="themeName">{{ nextThemeToUse.name }}</div>
              </div>

              <b-button
                v-if="nextThemeToUse"
                @click="changeTheme"
                variant="primary"
                size="sm"
                class="ml-1 text-capitalize align-self-center">
                change theme
              </b-button>
            </div>

            <SkeletonLoading :width="180" :height="100" class="mt-1 ml-1" v-if="loadingGetThemes"/>

            <div class="d-flex flex-wrap" v-if="!loadingGetThemes">
              <div class="" v-for="(theme, index) in themes" :key="index+'theme'">
                <div class="themeItemContainer m-1">
                  <div class="d-flex themeItemBorder">
                    <div class="themeItem cursor-pointer mb-1 border">
                      <div class="themeMockup" @click="selectNextTheme(theme)">
                        <div class="themeMockupHeader navbar rounded-top" :style="{ backgroundColor: theme.config.appColors.primary.value }"></div>
                        <div class="themeMockupContent d-flex justify-content-between">
                          <div class="leftsidenav w-25 border" :style="{ backgroundColor: theme.config.appColors.secondLight.value }"></div>
                          <div class="grid border w-50" :style="{ backgroundColor: theme.config.appColors.mainLight.value }">
                            <div class="grid-box"></div>
                            <div class="grid-box"></div>
                            <div class="grid-box"></div>
                            <div class="grid-box"></div>
                          </div>
                          <div class="rightsidenav border w-25" :style="{ backgroundColor: theme.config.appColors.secondLight.value }"></div>
                        </div>
                      </div>
                    </div>
                    <feather-icon
                      v-if="$can('update', 'AppColors') || $can('delete', 'AppColors')"
                      :id="`actions-theme-${theme.id}`"
                      icon="MoreVerticalIcon"
                      size="16"
                      class="cursor-pointer"
                    />
                    <b-popover
                      :target="`actions-theme-${theme.id}`"
                      triggers="focus"
                      placement="bottom"
                      custom-class="popover-p-0"
                      variant="white"
                    >
                      <b-list-group class="m-0">
                        <b-list-group-item
                          v-if="$can('update', 'AppColors')"
                          class="border-0"
                          button
                          @click="openThemeBuilder(theme)"
                        >
                          <feather-icon icon="EditIcon" />
                          <span class="align-middle ml-50 text-capitalize">
                            {{ $t("actions.edit") }}
                          </span>
                        </b-list-group-item>

                        <b-list-group-item
                          v-if="$can('delete', 'AppColors')"
                          class="border-0"
                          button
                          @click="deleteTheme(theme)"
                        >
                          <feather-icon icon="TrashIcon" />
                          <span class="align-middle ml-50 text-capitalize">
                            {{ $t("actions.delete") }}
                          </span>
                        </b-list-group-item>

                      </b-list-group>
                    </b-popover>
                  </div>
                  <div class="themeName">{{ theme.name }}</div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Pagination
          @updatePagination="updateCurrentPage"
          :totalList="themesTotalList"
          :currentPage="currentPageThemes"
          :perPage="perPageThemes">
        </Pagination>
      </b-col>
    </b-row>
    <ThemeBuilder
      v-if="showThemeBuilder"
      @closeThemeBuilder="closeThemeBuilder"
      :currentTheme="currentTheme"
      :isEdit="isEdit"
    />
  </div>
  <toastification-loading-content ref="loadingToast" />
  </b-card>
</template>

<script>
import { ref, onMounted } from "@vue/composition-api";
import { BButton, BRow, BCol, BCard, BDropdown } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationLoadingContent from "@core/components/toastification/ToastificationLoadingContent.vue";
import ThemeBuilder from "./themes/ThemeBuilder.vue";
import { useAppColors } from "@/composables/appColors";
import vSelect from "vue-select";
import Pagination from "@/components/Pagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";

export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    ToastificationLoadingContent,
    ThemeBuilder,
    vSelect,
    Pagination,
    SkeletonLoading,
    BDropdown
  },
  directives: {
    Ripple,
  },
  setup(_, context) {
    const {
      perPageThemes,
      currentPageThemes,
      search,
      themes,
      themesTotalList,
      tenantOptions,
      currentTenantSelected,
      loadingGetThemes,
      nextThemeToUse,
      currentThemeUsed,
      loadingToast,
      defaultTheme,
      getThemes,
      updateCurrentPage,
      onTypeSearch,
      deleteTheme,
      selectNextTheme,
      changeTheme
    } = useAppColors()

    onMounted(() => {
      getThemes()
    })

    const showThemeBuilder = ref(false)
    const isEdit = ref(false)
    const currentTheme = ref({})

    function openThemeBuilder(theme={}) {
      currentTheme.value = theme
      isEdit.value = theme.id ? true : false
      showThemeBuilder.value = true
    }

    function closeThemeBuilder(reload) {
      showThemeBuilder.value = false
      isEdit.value = false
      currentTheme.value = null
      if(reload) {
        getThemes();
      }
    }

    return {
      defaultTheme,
      showThemeBuilder,
      currentTheme,
      perPageThemes,
      currentPageThemes,
      search,
      themes,
      themesTotalList,
      tenantOptions,
      currentTenantSelected,
      loadingGetThemes,
      isEdit,
      nextThemeToUse,
      currentThemeUsed,
      loadingToast,
      closeThemeBuilder,
      openThemeBuilder,
      getThemes,
      updateCurrentPage,
      onTypeSearch,
      deleteTheme,
      selectNextTheme,
      changeTheme
    };
  },
};
</script>
